import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import './style.scss';
import Button from '../Button';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-left">
          <Link className="logo" to="/">
            <StaticImage src="./assets/logo.png" alt="Professional Standards Councils" width={160} />
          </Link>
          <div className="blurb">
            The Professional Standards Councils and its agency, the Professional Standards Authority, work to improve
            professional standards and protect consumers of professional services across Australia.
          </div>
        </div>

        <div className="footer-right">
          <ul>
            <li>
              <Button color="tertiary" to="/reports" label="View all reports" />
            </li>
            <li>
              <a href="https://www.psc.gov.au/" target="_blank" rel="noopener noreferrer">
                Professional Standards Councils Website
              </a>
            </li>
            <li>
              <Link to="https://www.psc.gov.au/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div className="copyright">Copyright &copy; {new Date().getFullYear()} Professional Standards Councils</div>
      </div>
    </footer>
  );
};

export default Footer;
